var cifSl = ["301 201", "<g fill='none'><path fill='#1EB53A' d='M.5.5h300v66.667H.5z'/><path fill='#FFF' d='M.5 67.167h300v66.667H.5z'/><path fill='#0072C6' d='M.5 133.833h300V200.5H.5z'/></g>"];

export { cifSl };
//# sourceMappingURL=cif-sl.js.map
